// requestedStatus: "Block" / "Unblock"
export default function changeCardStatus(setShowOverlay, setMessage, setError, requestedStatus, setCardStatus) {
  setShowOverlay(true);
  if (!window.OrendaGetResponse || window.isSiteBuilder) {
    setTimeout(() => {
      setCardStatus(requestedStatus === "Block" ? "Blocked" : "Active");
      setShowOverlay(false);
    }, 2000);
    return;
  }

  return window.OrendaGetResponse({ event_name: "changeCardStatus", data: JSON.stringify({"card_status_request": requestedStatus}) }, (response) => {
    if (response.error) return setError(true);

    if (response.message){
      setMessage(response.message);
      setShowOverlay(false);
      return;
    } 

    setMessage(response.cardStatus.current === "Deposit Only" ? "Your card has been blocked." : "Your card has been unblocked.");
    setCardStatus(response.cardStatus.current);
    setShowOverlay(false);
    return;
  });
}
